import { compose, withProps, lifecycle } from "recompose";
import { connect } from "react-redux";
import { parse } from "query-string";
import { createStructuredSelector } from "reselect";
import { withRouter } from "react-router-dom";
import { fetchApi } from "core/api/hoc";
import { createLoadingSelector } from "core/helpers";
import * as api from "modules/insiders/api";
import * as insidersSelectors from "modules/insiders/selectors";
import * as selectors from "modules/insiders/selectors";
import View from "./View";

export default compose(
  withRouter,
  lifecycle({
    componentDidMount() {
      this.props.history.replace(
        `/insiders/${this.props.match.params.id}/book`
      );
    }
  }),
  fetchApi(api.getInsider, ({ match }) => ({
    payload: {
      id: match.params.id
    },
    selector: insidersSelectors.getInsiderApi
  })),
  connect(
    createStructuredSelector({
      insider: selectors.fetchInsider,
      isLoading: createLoadingSelector(selectors.getInsiderApi)
    })
  ),
  withProps(props => ({
    backLink: parse(props.location.search).backLink
  }))
)(View);



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/Insider/Provider.js